import { withSandboxURL } from '../Authorize';

import GenericError from 'pages/Authorize/Errors/GenericError';
import { AppLink } from 'components/Link/AppLink';

const SandboxAccessDenied = () => (
  <GenericError title="Access Denied">
    You don&apos;t have access to the Finch Sandbox.{' '}
    <AppLink href={withSandboxURL()}>Click here</AppLink> to use the provider
    sandbox instead.
  </GenericError>
);

export default SandboxAccessDenied;
